<app-navigation></app-navigation>


<div class='container-fluid p-0'>
  <loading></loading>
  <router-outlet></router-outlet>
</div>


<app-footer></app-footer>